import React from 'react';
import { LanguageContext } from './contexts';

export const translateWithVariables = (translations: any, key: string, variables: any) => {
  if (translations === null) {
    return '';
  }

  let translated: string = translations[key];
  if (!translated) {
    translated = translations['error.translation_missing'];
  }

  if (variables !== undefined) {
    Object.keys(variables).forEach((property) => {
      translated = translated.replace(`{${property}}`, variables[property] !== undefined ? variables[property] : '');
    });
  }

  return translated;
}

export const withTranslate = (Component: any) => (props: any) => (
  <LanguageContext.Consumer>
    {({ language, translations, updateTranslations }) => {
      const translate = (key: string, variables: any) => {
        return translateWithVariables(translations, key, variables);
      };

      translate.has = (key: string) => {
        return translations && translations[key] !== undefined;
      };

      return (
        <Component
          language={language}
          translate={translate}
          translations={translations}
          updateTranslations={updateTranslations}
          {...props}
        />
      );
    }}
  </LanguageContext.Consumer>
);
